module.exports = __webpack_public_path__ + "img/md-mail-unread.b20afe46.svg";